import { useState } from "react";
import { SortOrder, ListTableSort, getEnumKeys, DropdownOption } from "sprint-common-web";

import { MuxerType } from "../../../common/types/MuxerType";

export interface MuxSpecificationListingFilters {
    sortBy: string;
    sortOrder: SortOrder;
    page: number;
    pageSize: number;
    name: string;
    typeId?: string;
}

const defaultFilters: MuxSpecificationListingFilters = {
    page: 1,
    pageSize: 50,
    sortBy: "name",
    sortOrder: "desc",
    name: "",
    typeId: undefined
};

export const useMuxSpecificationListingFilters = () => {
    const [filters, setFilters] = useState<MuxSpecificationListingFilters>(defaultFilters);

    const setSort = ({ by: sortBy, order: sortOrder }: ListTableSort) => {
        setFilters((prevFilters: MuxSpecificationListingFilters) => ({
            ...prevFilters,
            sortBy,
            sortOrder,
            page: 1
        }));
    };

    const setPage = (page: number) => {
        setFilters((prevFilters: MuxSpecificationListingFilters) => ({ ...prevFilters, page }));
    };

    const setPageSize = (pageSize: number): void => {
        setFilters((prevFilters: MuxSpecificationListingFilters) => ({ ...prevFilters, pageSize, page: 1 }));
    };

    const setName = (name: string): void => {
        setFilters((prevFilters: MuxSpecificationListingFilters) => ({ ...prevFilters, name, page: 1 }));
    };

    const setType = (option?: DropdownOption): void => {
        const muxerType = option?.key;

        setFilters((prevFilters: MuxSpecificationListingFilters) => ({
            ...prevFilters,
            typeId: muxerType ?? ""
        }));
    };

    const typeOptions: DropdownOption[] = getEnumKeys(MuxerType).map((item) => {
        return { key: item, text: item };
    });

    const clearFilters = (): void => {
        setFilters(defaultFilters);
    };

    return {
        filters,
        setSort,
        clearFilters,
        setPageSize,
        setPage,
        setName,
        setType,
        typeOptions
    };
};
